<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.note"
        :filters.sync="filters"
        @apply="$refs.notes.reload()"
        @ready="$refs.notes.load()"
      />

      <el-card shadow="never">
        <Notes
          ref="notes"
          :resource="$sdk.consignment"
          :identifier="$route.params.consignmentId"
          paginate
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Complex'
import Notes from '@/components/Notes'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    Filters,
    Notes
  },
  data () {
    return {
      title: 'Notes',
      breadcrumb: {
        name: 'Notes',
        route: { name: 'freight-consignments-v3-consignment-notes', params: { consignmentId: this.$route.params.consignmentId } }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'account_note'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => this.$refs['notes'].create()
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.$refs['notes'].reload()
        }
      ],
      loading: true,
      filters: []
    }
  }
}
</script>
